"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const SearchWithFilter_1 = __importDefault(require("@Components/Search/SearchWithFilter"));
const Button_1 = require("@Components/Buttons/Button");
const contexts_1 = require("@App/contexts");
const mobx_react_1 = require("mobx-react");
const publisher_form_type_1 = require("@App/enum/publisher-form-type");
const PublisherSearchResultsTable_1 = __importDefault(require("@Components/WorkRegistrationSubs/PublisherFormSteps/PublisherSearchResultsTable"));
require("./index.scss");
const PublisherAddForm = (props) => {
    const { publisherSearchStore, publisherStepStore } = (0, react_1.useContext)(contexts_1.StoresContext);
    const { itemWasAdded, setFoundPublisherToDraft, topClass, title, subtitle, searchFilterPlaceholder, suggestedTitle, buttonText, isAdministrator, } = props;
    const [searchWasPerformed, setSearchWasPerformed] = (0, react_1.useState)(false);
    // TODO: Should set name/Ipi in the same function. Logic = if Ipi { set IPI} else {set Name}.
    // TODO: This should probably be handled in the publisherSearchStore.
    const setPublisherNameToSearch = (value) => {
        const publishersSearch = Object.assign(Object.assign({}, publisherSearchStore.publisherSearch), { publisherName: value, publisherIpi: null });
        publisherSearchStore.setPublisherSearch(publishersSearch);
    };
    const onSubmitSingleSearch = (value) => __awaiter(void 0, void 0, void 0, function* () {
        const publishersSearch = Object.assign(Object.assign({}, publisherSearchStore.publisherSearch), { publisherName: value, publisherIpi: null });
        publisherSearchStore.setPublisherSearch(publishersSearch);
        yield publisherSearchStore.searchPublishers(true);
        setSearchWasPerformed(true);
    });
    const onClear = () => {
        publisherSearchStore.clearStore();
        setSearchWasPerformed(false);
    };
    (0, react_1.useEffect)(() => {
        onSubmitSingleSearch('').then();
    }, []);
    const searchResult = publisherSearchStore.publisherSearchModel;
    const publisherSearchModelHasData = searchResult && searchResult.count > 0;
    const CreateNewPublisherSection = () => (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement("p", { className: 'cant-find-title' }, "Can't find what you're looking for?"),
        react_1.default.createElement("div", { className: 'sidebar-wizard-button-container' },
            react_1.default.createElement(Button_1.Button, { mainColor: true, type: 'secondary', className: "sidebar-wizard-button", onClick: () => publisherStepStore.setFormType(publisher_form_type_1.PublisherFormType.create) }, buttonText))));
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement("div", { className: topClass },
            react_1.default.createElement("h2", null, title),
            react_1.default.createElement("h5", { className: 'medium subtitle' }, subtitle),
            react_1.default.createElement(SearchWithFilter_1.default, { mainColor: true, id: 'publisher-search', onChangeInput: setPublisherNameToSearch, value: publisherSearchStore.publisherSearch && publisherSearchStore.publisherSearch.publisherName, placeholder: searchFilterPlaceholder, withFilter: false, buttonClick: onSubmitSingleSearch, onClearInput: onClear }),
            publisherSearchStore.isSearching ? (react_1.default.createElement("p", null, "Searching, please wait...")) : (publisherSearchModelHasData && (react_1.default.createElement(react_1.default.Fragment, null,
                react_1.default.createElement(PublisherSearchResultsTable_1.default, { suggestedTitle: suggestedTitle, setFoundPublisherToDraft: setFoundPublisherToDraft, itemWasAdded: itemWasAdded, showMLCPublisherNumber: true, buttonText: isAdministrator ? 'Add administrator' : 'Add publisher' }),
                react_1.default.createElement(CreateNewPublisherSection, null)))),
            searchWasPerformed && !publisherSearchModelHasData && (react_1.default.createElement(react_1.default.Fragment, null,
                react_1.default.createElement("p", { className: 'suggested-title' }, "Not found"),
                react_1.default.createElement(CreateNewPublisherSection, null))))));
};
exports.default = (0, mobx_react_1.observer)(PublisherAddForm);
